import { useMemo } from "react";
import { tabTypes } from "../constants/tab-types";

const formatTools = (tools, isMainTab) => (isMainTab && !!tools ? tools : null);

export const useMobileRightRailContent = ({ ancillaryData, tabType }) => {
  const toolsMap = useMemo(
    () =>
      ancillaryData.reduce((acc, tool) => {
        acc[tool.type] = tool;
        return acc;
      }, {}),
    [ancillaryData]
  );

  const {
    DDToolsRightRailSection: ddToolsData,
    RelatedDMTopicsRightRailSection: relatedTopicsData,
    RelatedContentRightRailSection: relatedContentData,
  } = toolsMap;

  const isMainTab = tabType === undefined || tabType === tabTypes.DETAILS;

  return {
    ddToolsData: formatTools(ddToolsData, isMainTab),
    relatedTopicsData: formatTools(relatedTopicsData, isMainTab),
    relatedContentData: formatTools(relatedContentData, isMainTab),
  };
};
